import React from "react"
import clsx from "clsx"
import NoteBuilder from "../../NoteBuilder/NoteBuilder"

class HoldBuilderNotes extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "notes",
      'tab-pane': true
    });

    return(
      <div className={tabClasses} id="notes">
        <NoteBuilder note={this.props.note_obj} new_record={true} onChangeNote={this.props.onChangeNote} onChangeFileUploadGroup={this.props.onChangeFileUploadGroup} onChangeFlagged={this.props.onChangeFlagged} buttons={this.props.buttons} />
      </div>
    )

  }
}

export default HoldBuilderNotes
